var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('mpx-view',{staticClass:"mask",class:((_vm.externClass)+" "+(_vm.show ? "show" : "hide")),style:(_vm._f("transRpxStyle")([(_vm.externStyle)])),on:{"tap":_vm.close}})
}
var staticRenderFns = []

export { render, staticRenderFns }